import { Plus } from "lucide-react"

import CheckmarkIcon from "@/components/icons/CheckmarkIcon"
import PulseLineIcon from "@/components/icons/PulseLineIcon"
import TombstonesIcon from "@/components/icons/TombstonesIcon"
import { Button } from "@/components/ui/button"

interface EmptyTaskStateProps {
  status: "active" | "completed" | "archived"
  onAddTask?: () => void
}

export default function EmptyTaskState({
  status,
  onAddTask,
}: EmptyTaskStateProps) {
  const messages = {
    active: {
      title: "Nothing on the line.",
      description: "Add a task to give it a deadline.",
      showButton: true,
      icon: <PulseLineIcon className="text-bone-dim h-10 w-32" />,
    },
    completed: {
      title: "Clean slate.",
      description: "Completed tasks will rest here.",
      showButton: false,
      icon: <CheckmarkIcon className="text-green h-12 w-12" />,
    },
    archived: {
      title: "The graveyard is empty.",
      description: "Tasks that missed their deadline end up here.",
      showButton: false,
      icon: <TombstonesIcon className="text-bone-dim h-12 w-20" />,
    },
  }

  const message = messages[status]

  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      {message.icon && <div className="mb-4">{message.icon}</div>}
      <h3 className="text-bone-muted mb-1 text-base font-medium">
        {message.title}
      </h3>
      <p className="text-bone-dim mb-4 text-sm">{message.description}</p>
      {message.showButton && onAddTask && (
        <Button
          onClick={onAddTask}
          size="sm"
          data-testid="empty-state-add-task"
        >
          <Plus className="mr-2 h-4 w-4" />
          Add Task
        </Button>
      )}
    </div>
  )
}
